import api from "../api"
import { adapterSocialMedia } from "./adapter-social-media"

/**
 * Adapter for Individual Account Type
 *
 * Adapt data from API response,
 * into structured data for rendering, or
 * initial form's state purpose.
 *
 * @param {object} account
 *
 */
function adapterIndividu(account, isForm){
  let result = {}

  // Get 'individu' data inside 'account' object
  if(account.individu && account.individu[0]){
    const individu = account.individu[0]

    const status = isForm && individu.statusIndividu && individu.statusIndividu !== null ? individu.statusIndividu.id : individu.statusIndividu

    result = {
      typeAccount: account.typeAccount ? account.typeAccount.id : '',
      accountId: account.accountId,
      id: individu.userId,
      userId: individu.userId,
      name: individu.namaIndividu,
      image: api.base_image+individu.imgFotoProfile,
      content: individu.tentangSaya,
      status,
      institution: individu.institusi,
      email: individu.email,
      gender: {
        label: individu.typeGender?.nama[0],
        value: individu.typeGender?.id,
      },
      disability: {
        label: individu.typeDifable?.nama[0],
        value: individu.typeDifable?.id,
      },
      occupation: {
        label: individu.pekerjaan?.nama[0],
        value: individu.pekerjaan?.id,
      },

      // Social Links for rendering purpose
      socialLinks: adapterSocialMedia.APIToForm(individu.sosialMedia, {}),

      // Social links for profile form's default values purpose
      ...adapterSocialMedia.APIToForm(individu.sosialMedia, {isFlat: true})
    }
  }

  return result
}

export { adapterIndividu }
